import RssLink from './RssLink';

export default RssLink;
